import { render, staticRenderFns } from "./MasterTopBar.vue?vue&type=template&id=3dd03c24&scoped=true"
import script from "./MasterTopBar.vue?vue&type=script&lang=js"
export * from "./MasterTopBar.vue?vue&type=script&lang=js"
import style0 from "./MasterTopBar.vue?vue&type=style&index=0&id=3dd03c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd03c24",
  null
  
)

export default component.exports